import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import English from './lang/en.json';
import French from './lang/fr.json';
import Indonesian from './lang/id.json';
import SimplifiedChinese from './lang/zh-Hans.json';
import TraditionalChinese from './lang/zh-Hant.json';
import Arabic from './lang/ar.json';
import Thai from './lang/th_TH.json';
import Vietnamese from './lang/vi_VN.json';
import Portuguese from './lang/pt.json';
import Spanish from './lang/es.json';
import Japanese from './lang/ja.json';
import { IntlProvider } from 'react-intl';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './styles/theme';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SetupProfile } from './pages/SetupProfile';
import { Success } from './pages/Success';
import { Error } from './pages/Error';
import { TermsOfUse } from './pages/TermsOfUse';
import { getEnv, getLocale } from './utils/utils';
import * as Sentry from '@sentry/react';

const locale = getLocale();
let lang;
switch (locale) {
  case 'fr':
    lang = French;
    break;
  case 'id':
    lang = Indonesian;
    break;
  case 'zh-Hans':
    lang = SimplifiedChinese;
    break;
  case 'zh-Hant':
    lang = TraditionalChinese;
    break;
  case 'ar':
    lang = Arabic;
    break;
  case 'th':
    lang = Thai;
    break;
  case 'vi':
    lang = Vietnamese;
    break;
  case 'pt':
    lang = Portuguese;
    break;
  case 'es':
    lang = Spanish;
    break;
  case 'ja':
    lang = Japanese;
    break;
  default:
    lang = English;
    break;
}

const env = getEnv();
if (env == 'production' || env == 'staging') {
  Sentry.init({
    dsn: 'https://cb687feb00f4a046af9323f886680a9e@o308419.ingest.sentry.io/4506312838086656',
    environment: env,
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [
          'https://signup.app-staging.novade.net/',
          'https://signup.app.novade.net/',
        ],
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.2,
    // Session Replay
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <IntlProvider locale={locale} messages={lang}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Routes>
            <Route
              path="/accept-invite"
              element={<SetupProfile isCreatingWorkspace={false} />}
            ></Route>
            <Route
              path="/sign-up-final"
              element={<SetupProfile isCreatingWorkspace={true} />}
            ></Route>
            <Route path="/success" element={<Success />}></Route>
            <Route path="/error" element={<Error />}></Route>
            <Route path="/terms-of-use" element={<TermsOfUse />}></Route>
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </IntlProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
